// extracted by mini-css-extract-plugin
module.exports = {"m1hl6blq":"m1hl6blq"};